import localForage from "localforage";

export const COMMON_IS_LOADING = "COMMON_IS_LOADING";
export const COMMON_ALERT_OPEN = "COMMON_ALERT_OPEN";
export const COMMON_ALERT_CLOSE = "COMMON_ALERT_CLOSE";

export const COMMON_FETH_DATA = "COMMON_FETH_DATA";
export const COMMON_FETCH_DATA_SUCCESS = "COMMON_FETCH_DATA_SUCCESS";
export const COMMON_FETCH_DATA_ERROR = "COMMON_FETCH_DATA_ERROR";

export const COMMON_FETCH_COUNTRIES = "COMMON_FETCH_COUNTRIES";
export const COMMON_FETCH_COUNTRIES_SUCCESS = "COMMON_FETCH_COUNTRIES_SUCCESS";
export const COMMON_FETCH_COUNTRIES_ERROR = "COMMON_FETCH_COUNTRIES_ERROR";

export const isLoading = (is_loading) => ({
  type: COMMON_IS_LOADING,
  is_loading: is_loading
})

// type: ["success","warning","error","info"]
export const common_alertOpen = (message, type = 'error') => ({
  type: COMMON_ALERT_OPEN,
  alert: {
      open: true,
      type: type,
      message: message
  }
})

export const common_alertClose = (type='error') => ({
  type: COMMON_ALERT_CLOSE,
  alert: {
      open: false,
      type: type
  }
})

export const common_fetchData = (params) => {
  return { 
      type: COMMON_FETH_DATA, 
      payload: {
          request: {
              url: 'common/',
              params: params
          },
          options: {
              onSuccess({ getState, dispatch, response }) {
                 dispatch({ type: COMMON_FETCH_DATA_SUCCESS, payload: response.data });
              }, 
              onError({ getState, dispatch, error }) {
                 dispatch({ type: COMMON_FETCH_DATA_ERROR, payload: error.message });
              },
          }
      } 
  }
};

export const common_fetchCountries = (params) => {
  return { 
      type: COMMON_FETH_DATA, 
      payload: {
          request: {
              url: 'geo/countries/',
              params: params
          },
          options: {
              onSuccess({ getState, dispatch, response }) {
                 localForage.setItem('countries', response.data).then((response) => {
                     dispatch({ type: COMMON_FETCH_COUNTRIES_SUCCESS, payload: response });
                 })
              }, 
              onError({ getState, dispatch, error }) {
                 dispatch({ type: COMMON_FETCH_COUNTRIES_ERROR, payload: error.message });
              },
          }
      } 
  }
};


// WEBPACK FOOTER //
// ./src/redux/actions/commonActions.js